const global = window

inputs.types.editor = function (data, name, niceName, type, input, parent, inputWindow) {
    pluginEditor.init(input, 'txtEditor');
    return data
}
